module.exports = __webpack_public_path__ + "img/empty-cart.2bfb7521.png";